var uiPagination = {
	caption: "Seitenzahlen",
	page: "Seite {page}",
	first: "Erste Seite",
	previous: "Vorherige Seite",
	next: "Nächste Seite",
	last: "Letzte Seite"
};
var de = {
	uiPagination: uiPagination
};

export { de as default, uiPagination };
